import { useRouteContext } from "@tanstack/react-router";

export function useColors() {
	const { club } = useRouteContext({ from: "__root__" });

	const style = club.themes?.[0].styles;

	return style as Record<string, string>;
}
